var path = 'app/scripts/modules/core/src/insight/insightFilter.component.html';
var html = "<h3 class=\"filters-placeholder\">\n  <a href\n     class=\"btn btn-xs btn-default pin\"\n     ng-click=\"$ctrl.insightFilterStateModel.pinFilters(true)\"\n     uib-tooltip=\"Show filters\">\n    <i class=\"fa fa-forward\"></i>\n  </a>\n</h3>\n\n<a href\n   class=\"btn btn-xs btn-default pull-right unpin\"\n   ng-click=\"$ctrl.insightFilterStateModel.pinFilters(false)\"\n   ng-show=\"$ctrl.insightFilterStateModel.filtersExpanded\">\n  <i class=\"fa fa-backward\" uib-tooltip=\"Hide filters\"></i>\n</a>\n\n<div ng-transclude class=\"insight-filter-content\"></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/insight/insightFilter.component.html
// module id = 972
// module chunks = 0